import React, { useState, useEffect, useContext } from 'react';

import Cookies from 'js-cookie';
import axios from 'axios';

import Dropdown from '../common/Dropdown'
import ViewMenu from './ViewMenu.jsx'
import CampaignMenu from './CampaignMenu.js'
import DiscordMenu from './DiscordMenu.jsx'

import { UserDataContext } from "../../App.js";

import { charsheetAPI, DEFAULT_CAMPAIGN, DISCORD_CLIENT_ID } from '../../globals.js';
import getAllUsers from '../../helpers/getAllUsers.js';
import getAccessToken from '../../helpers/getAccessToken.js';
// import createUser from '../../helpers/createUser.js';
import createCampaign from '../../helpers/createCampaign.js';
import createUser from '../../helpers/createUser.js';
import getCampaignCharacters from '../../helpers/getCampaignCharacters.js';

import { generateCharacter  } from '../../helpers/randomCharacter.js';

import './CampaignMenu.css';

// ----------------------------------------------------------------------------------
//                         Description
//
//     SettingsButton is a temporary placeholder for now. Will eventually navigate to a new page
//  
//     div == .navbaritem
//       button == #nav-menu-settings .nav-menu-button
//         menu items == .menu .spells-menu > li > button
//
//     (c) DXA Development 2023
// ----------------------------------------------------------------------------------


// -----------  HANDLE DISCORD LOGIN ----------------
const handleDiscordLogin = (isTTS=false) => {
    
        // get the hostname
        var currentHost = window.location.host;

        // remove the www. if it's there
        if (currentHost.slice(0, 3) === "www" ) {
            currentHost = currentHost.slice(4);
        }

        // check for TTS
        if (isTTS) {
            // prompt user to manually enter the discord token
            alert("Prepare to enter Discord token by logging in to advancedgamemaster.com via a desktop browser.\n\nYou can then find it in the desktop browser Developer Tools (F12) > Application > Local Storage > discord_token");
            var discordToken = prompt("Enter your Discord token:", "");
             // typical URL: http://10.0.0.126:3000/oauth2/callback/#token_type=Bearer&access_token=FG2Jq8auzDIgwHddsYiyy3kLAZ3mjG&expires_in=604800&scope=identify
            if (discordToken === null || discordToken === "") {
                alert("User cancelled the prompt.");
                return;
            } else {
                // create a new URL object using the format for typical URL
                var url = new URL("http://" + currentHost + "/oauth2/callback/");
                url.hash = "token_type=Bearer&access_token=" + discordToken + "&expires_in=604800&scope=identify";
                window.open(url, '_self');
                return;
            }
        }

        // set up the auth & callback URL
        var discordAuthUrl = `https://discord.com/api/oauth2/authorize?client_id=${DISCORD_CLIENT_ID}&response_type=token&scope=identify&`
        
        discordAuthUrl += "redirect_uri=https://" + currentHost + "/oauth2/callback/"

        // open discord to allow user to authenticate
        window.open(discordAuthUrl, '_self');
  };

  /* const handleDiscordLogout = () => {
    localStorage.removeItem("discord_token");
    setUserData({username: 'Log In', loggedIn: false})
  }; */

function SettingsButton(props) {

    // ------------ parameters ---------------

    // ------ inherited state variables ------
    let [currentChar, setChar] = [ props.state[0], props.state[1] ];
    let [layout, setLayout] = [ props.state[3], props.state[4] ];
    const [userData, setUserData] = useContext(UserDataContext);
    const [isPlaying, setIsPlaying] = props.state[8];

    // -------- local state variables --------
    const [isTTS, setIsTTS] = useState(/Tabletop/i.test(navigator.userAgent));


    // ------------- useEffect ---------------
    /*
    useEffect( () => {

        async function DoSomething () {    
          
        }

        DoSomething();

    }, [] ); //useEffect
    */


    // let menuOptions = [userData.username,'Change Campaign','View N characters', 'Play Songs', 'Campaign Discord', 'Development Discord', 'Help'] ;
    let showDebug = false;
    
    let menuOptions = [
        userData.username,
        ...( (userData.loggedIn && showDebug) ? ['Get User'] : []),
        ...(userData.loggedIn ? ['Change Campaign'] : []),
        'View',
        ...(userData.loggedIn ? ['Play Songs'] : []),
        'Discord',
        'Help'
      ];
      
    let gearIcon = require('../../img/gear.png');

    const handleMenu = async (selection) => {
        // Implement the various menu options here

        // ----------  LOG IN --------------
        if (menuOptions[selection] === 'Log In') {
            handleDiscordLogin( isTTS);
        }


        // ----------  LOG OFF --------------
        else if (menuOptions[selection] === userData.username) {
            try {
                await axios.post(charsheetAPI + '?TableName=logout', null, { withCredentials: true });
            } catch (err) {
                console.warn('Logout call failed (clearing client state anyway):', err);
            }
            setUserData({username: 'Log In', loggedIn: false});
            Cookies.set('currentCampaign', DEFAULT_CAMPAIGN);
        }


        // ----------  GET USER --------------
        else if (menuOptions[selection] === 'Get User') {

            // const tokenData = await getAccessToken( userData.uniqueUser, localStorage.getItem('discord_token') );
            // console.log('token:', tokenData );
            // const { token } = await tokenData; 

            // const allUsers = await getAllUsers();
                
            console.log('userData', userData);
            console.log('userDynamoData', userData.dynamoData);
            console.log('userCampaigns', userData.dynamoData.campaigns);
            alert(JSON.stringify(userData.dynamoData, null, 2));

            const charactersInCampaign = await getCampaignCharacters (userData.currentCampaign);
            console.log('charactersInCampaign', charactersInCampaign);


        }
           

        // ----------  PLAY SONGS --------------
        else if (menuOptions[selection] === 'Play Songs') {

            // toggle #songPlayerDiv display on/off

            var songPlayerDiv = document.getElementById('songPlayerDiv');

            if ((songPlayerDiv.style.display === 'none') || (songPlayerDiv.style.display === '')) {
                songPlayerDiv.style.display = 'flex';
            } else {
                songPlayerDiv.style.display = 'none';
            }

            if (isPlaying === undefined) setIsPlaying(true);
            //else 
            //    if (songPlayerDiv.style.display != 'none')
            //        setIsPlaying(!isPlaying);
        } 


        // -------------- HELP ------------------
        else {
        
        if ( menuOptions[selection] === 'Help' ) {

            // document.getElementById('help-menu').style.display = 'flex';
            document.getElementById('helpWindow').style.display = 'block';

            } else {
                alert('Future feature');
            }
        }


    }
    
    // ------------  Return JSX  ----------------
    
    return (
    
        <>
        <Dropdown
            divClass='navbaritem'
            trigger = {<button id="nav-settings-button" className="nav-menu-button"><div id='settings-text'>Settings </div><div id='gear-icon-div'><img src={gearIcon} alt='Settings' id='gear-icon'/></div></button>}
            menu = { menuOptions.map ( ( option, idx) => {

                if  ( option === 'Change Campaign' ) return <CampaignMenu key={idx} {...props} />

                if  ( option === 'View' ) return <ViewMenu key={idx} {...props} />

                if  ( option === 'Discord' ) return <DiscordMenu key={idx} {...props} />

                else return <button id={'settings-option-' + idx } onClick={()=>handleMenu(idx)}>{option}</button>

                }
            )}
            menuClass='menu settings-menu'
        />
        </>
    )

    };  // end of function

    export default SettingsButton